<!--
 * @Author: your name
 * @Date: 2021-07-15 10:55:36
 * @LastEditTime: 2021-07-27 10:25:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SurgicalCommunication\src\pages\pdf.vue
-->
<template>
    <div class="pdfTest">
      <pdf v-for="i in numPages" :key="i" :page="i" ref="pdf" src="./agree.pdf"></pdf>
      <!-- <iframe style="width:100%;height:100%;" src="./agree.pdf#toolbar=0" frameBorder="0"></iframe> -->
    </div>
</template>

<script>
import {  } from 'view-design'
import pdf  from "vue-pdf"
export default {
    components: {
      pdf 
    },
    data() {
        return {
          numPages:null
        };
    },
    methods: {
      getNumPages() {
        let loadingTask = pdf.createLoadingTask("./agree.pdf")
        loadingTask.promise.then(pdf => {
          this.numPages = pdf.numPages
        //   console.log(pdf.numPages)
        }).catch(err => {
          console.error('pdf 加载失败', err);
        })
      }
    },
    created() {

    },
    mounted() {
      this.getNumPages()
    },
}
</script>
<style lang='less'>
.pdfTest{
  height: 100%;
}
</style>